module.exports = __webpack_public_path__ + "img/arrow-down.6a91ff08.svg";